import { ExportItemEnum } from 'APIPackage/ImportExportModule/enums/ExportItemEnum';

export const mapStatusNamesByCode: Record<string, ExportItemEnum> = {
  Новый: ExportItemEnum.NEW,
  'Выгрузка успешно сформирована': ExportItemEnum.DONE,
  'В процессе обработки': ExportItemEnum.IN_PROGRESS,
  'Ошибка формирования выгрузки': ExportItemEnum.ERROR,
};
